import prop from 'ramda/src/prop'
import { camelCaseSpace, capitalize } from 'root/src/shared/util/stringCase'
import {
	readablePlatformsMap,
	readableKeyTypesMap,
	dropKeyPlatformRegionsOptionsMap,
} from 'root/src/shared/constants/dropKeys'
import { RewardType } from 'root/src/shared/rewards/constants'

const typePartMap = {
	[RewardType.CUSTOM]: 'for viewers',
	[RewardType.KEY]: 'for viewers',
	[RewardType.CODE]: 'for viewers',
	[RewardType.BUNDLE]: 'for viewers',
	[RewardType.EXTERNAL_API_FULFILLED]: 'for viewers',
	[RewardType.PLACEHOLDER]: '',
}

export const getFullKeyName = (
	{ game, keyType, region, platform },
) => `${prop('name', game)} ${readablePlatformsMap[platform]} ${camelCaseSpace(region)} ${readableKeyTypesMap[keyType]} Key`

export default (
	{ amount = 0, name = '', type = '', region = '', platform = '' }, forViewers = false,
) => {
	let finalName = ''

	if (amount) {
		finalName += `(${amount}) `
	}
	finalName += `${name} `
	if (region) {
		finalName += `${getRegionLabelByPlatform({ region, platform })} `
	}
	if (forViewers) {
		finalName += typePartMap[type]
	}

	return finalName.trim()
}

/**
 * Get region label by platform
 * @param {{
 *   region: string,
 *   platform: string
 * }} params
 * @return {string}
 */
export function getRegionLabelByPlatform(params) {
	const { region, platform } = params
	const option = dropKeyPlatformRegionsOptionsMap[platform]
	const regionOption = option?.find(({ value }) => value === region)

	if (!regionOption) {
		return capitalize(region)
	}

	return regionOption.label
}
